"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.small.js");
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _polished = require("polished");
var _styledComponents = require("styled-components");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _templateObject;
function cov_2hh8p0e50c() {
  var path = "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/buttonStyles.js";
  var hash = "f30c06793fc3f7f9e10750b7e50ebcd98bb7450c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/buttonStyles.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 41
        },
        end: {
          line: 6,
          column: 57
        }
      },
      "1": {
        start: {
          line: 8,
          column: 20
        },
        end: {
          line: 8,
          column: 95
        }
      },
      "2": {
        start: {
          line: 8,
          column: 29
        },
        end: {
          line: 8,
          column: 95
        }
      },
      "3": {
        start: {
          line: 10,
          column: 21
        },
        end: {
          line: 138,
          column: 1
        }
      },
      "4": {
        start: {
          line: 15,
          column: 21
        },
        end: {
          line: 15,
          column: 73
        }
      },
      "5": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 18,
          column: 77
        }
      },
      "6": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 33,
          column: 77
        }
      },
      "7": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 37,
          column: 89
        }
      },
      "8": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 43,
          column: 23
        }
      },
      "9": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 80
        }
      },
      "10": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 78,
          column: 3
        }
      },
      "11": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 83,
          column: 5
        }
      },
      "12": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 97,
          column: 3
        }
      },
      "13": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 102,
          column: 3
        }
      },
      "14": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 118,
          column: 3
        }
      },
      "15": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 130,
          column: 3
        }
      },
      "16": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 137,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 20
          },
          end: {
            line: 8,
            column: 21
          }
        },
        loc: {
          start: {
            line: 8,
            column: 29
          },
          end: {
            line: 8,
            column: 95
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 12
          },
          end: {
            line: 15,
            column: 13
          }
        },
        loc: {
          start: {
            line: 15,
            column: 21
          },
          end: {
            line: 15,
            column: 73
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 16,
            column: 5
          }
        },
        loc: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 18,
            column: 77
          }
        },
        line: 17
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 30,
            column: 11
          },
          end: {
            line: 30,
            column: 12
          }
        },
        loc: {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 33,
            column: 77
          }
        },
        line: 31
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 34,
            column: 22
          },
          end: {
            line: 34,
            column: 23
          }
        },
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 89
          }
        },
        line: 35
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 7
          }
        },
        loc: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 43,
            column: 23
          }
        },
        line: 41
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 44,
            column: 19
          },
          end: {
            line: 44,
            column: 20
          }
        },
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 80
          }
        },
        line: 45
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 53
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 78,
            column: 7
          },
          end: {
            line: 78,
            column: 8
          }
        },
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        },
        line: 79
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        },
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 92
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        },
        loc: {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 102,
            column: 3
          }
        },
        line: 99
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        },
        loc: {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 118,
            column: 3
          }
        },
        line: 104
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 5
          }
        },
        loc: {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 130,
            column: 3
          }
        },
        line: 120
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 131,
            column: 5
          }
        },
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        },
        line: 132
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 29
          },
          end: {
            line: 8,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 30
          },
          end: {
            line: 8,
            column: 48
          }
        }, {
          start: {
            line: 8,
            column: 52
          },
          end: {
            line: 8,
            column: 79
          }
        }, {
          start: {
            line: 8,
            column: 84
          },
          end: {
            line: 8,
            column: 95
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 18,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 17,
            column: 21
          }
        }, {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 18,
            column: 77
          }
        }],
        line: 17
      },
      "2": {
        loc: {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 33,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 8
          },
          end: {
            line: 32,
            column: 64
          }
        }, {
          start: {
            line: 33,
            column: 8
          },
          end: {
            line: 33,
            column: 77
          }
        }],
        line: 31
      },
      "3": {
        loc: {
          start: {
            line: 32,
            column: 8
          },
          end: {
            line: 32,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 8
          },
          end: {
            line: 32,
            column: 26
          }
        }, {
          start: {
            line: 32,
            column: 30
          },
          end: {
            line: 32,
            column: 64
          }
        }],
        line: 32
      },
      "4": {
        loc: {
          start: {
            line: 33,
            column: 8
          },
          end: {
            line: 33,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 33,
            column: 27
          }
        }, {
          start: {
            line: 33,
            column: 31
          },
          end: {
            line: 33,
            column: 59
          }
        }, {
          start: {
            line: 33,
            column: 64
          },
          end: {
            line: 33,
            column: 77
          }
        }],
        line: 33
      },
      "5": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 36,
            column: 21
          }
        }, {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 89
          }
        }],
        line: 35
      },
      "6": {
        loc: {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 37,
            column: 27
          }
        }, {
          start: {
            line: 37,
            column: 31
          },
          end: {
            line: 37,
            column: 65
          }
        }, {
          start: {
            line: 37,
            column: 70
          },
          end: {
            line: 37,
            column: 89
          }
        }],
        line: 37
      },
      "7": {
        loc: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 43,
            column: 23
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 10
          },
          end: {
            line: 42,
            column: 91
          }
        }, {
          start: {
            line: 43,
            column: 10
          },
          end: {
            line: 43,
            column: 23
          }
        }],
        line: 41
      },
      "8": {
        loc: {
          start: {
            line: 42,
            column: 10
          },
          end: {
            line: 42,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 11
          },
          end: {
            line: 42,
            column: 29
          }
        }, {
          start: {
            line: 42,
            column: 33
          },
          end: {
            line: 42,
            column: 67
          }
        }, {
          start: {
            line: 42,
            column: 72
          },
          end: {
            line: 42,
            column: 91
          }
        }],
        line: 42
      },
      "9": {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 5
          },
          end: {
            line: 45,
            column: 23
          }
        }, {
          start: {
            line: 45,
            column: 27
          },
          end: {
            line: 45,
            column: 58
          }
        }, {
          start: {
            line: 45,
            column: 63
          },
          end: {
            line: 45,
            column: 80
          }
        }],
        line: 45
      },
      "10": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 78,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 19
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 78,
            column: 3
          }
        }],
        line: 53
      },
      "11": {
        loc: {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 9
          },
          end: {
            line: 60,
            column: 27
          }
        }, {
          start: {
            line: 60,
            column: 31
          },
          end: {
            line: 60,
            column: 65
          }
        }, {
          start: {
            line: 60,
            column: 70
          },
          end: {
            line: 60,
            column: 89
          }
        }],
        line: 60
      },
      "12": {
        loc: {
          start: {
            line: 62,
            column: 15
          },
          end: {
            line: 62,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 16
          },
          end: {
            line: 62,
            column: 34
          }
        }, {
          start: {
            line: 62,
            column: 38
          },
          end: {
            line: 62,
            column: 66
          }
        }, {
          start: {
            line: 62,
            column: 71
          },
          end: {
            line: 62,
            column: 84
          }
        }],
        line: 62
      },
      "13": {
        loc: {
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 17
          },
          end: {
            line: 64,
            column: 35
          }
        }, {
          start: {
            line: 64,
            column: 39
          },
          end: {
            line: 64,
            column: 67
          }
        }, {
          start: {
            line: 64,
            column: 72
          },
          end: {
            line: 64,
            column: 85
          }
        }],
        line: 64
      },
      "14": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 9
          },
          end: {
            line: 70,
            column: 27
          }
        }, {
          start: {
            line: 70,
            column: 31
          },
          end: {
            line: 70,
            column: 65
          }
        }, {
          start: {
            line: 70,
            column: 70
          },
          end: {
            line: 70,
            column: 89
          }
        }],
        line: 70
      },
      "15": {
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 15
          }
        }, {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        }],
        line: 79
      },
      "16": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 97,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 15
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 97,
            column: 3
          }
        }],
        line: 92
      },
      "17": {
        loc: {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 102,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 99,
            column: 15
          }
        }, {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 102,
            column: 3
          }
        }],
        line: 99
      },
      "18": {
        loc: {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 118,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 104,
            column: 18
          }
        }, {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 17
          }
        }, {
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 118,
            column: 3
          }
        }],
        line: 104
      },
      "19": {
        loc: {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 130,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 120,
            column: 14
          }
        }, {
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 130,
            column: 3
          }
        }],
        line: 120
      },
      "20": {
        loc: {
          start: {
            line: 123,
            column: 13
          },
          end: {
            line: 123,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 14
          },
          end: {
            line: 123,
            column: 32
          }
        }, {
          start: {
            line: 123,
            column: 36
          },
          end: {
            line: 123,
            column: 70
          }
        }, {
          start: {
            line: 123,
            column: 75
          },
          end: {
            line: 123,
            column: 94
          }
        }],
        line: 123
      },
      "21": {
        loc: {
          start: {
            line: 128,
            column: 15
          },
          end: {
            line: 128,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 128,
            column: 16
          },
          end: {
            line: 128,
            column: 34
          }
        }, {
          start: {
            line: 128,
            column: 38
          },
          end: {
            line: 128,
            column: 72
          }
        }, {
          start: {
            line: 128,
            column: 77
          },
          end: {
            line: 128,
            column: 96
          }
        }],
        line: 128
      },
      "22": {
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 18
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        }],
        line: 132
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0, 0],
      "13": [0, 0, 0],
      "14": [0, 0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0, 0],
      "19": [0, 0],
      "20": [0, 0, 0],
      "21": [0, 0, 0],
      "22": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f30c06793fc3f7f9e10750b7e50ebcd98bb7450c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2hh8p0e50c = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2hh8p0e50c();
var _ref = (cov_2hh8p0e50c().s[0]++, _stylingConstants.default),
  border = _ref.border,
  color = _ref.color,
  font = _ref.font,
  spacing = _ref.spacing;
cov_2hh8p0e50c().s[1]++;
var getFontSize = function getFontSize(props) {
  cov_2hh8p0e50c().f[0]++;
  cov_2hh8p0e50c().s[2]++;
  return (cov_2hh8p0e50c().b[0][0]++, props.theme.button) && (cov_2hh8p0e50c().b[0][1]++, props.theme.button.textSize) || (cov_2hh8p0e50c().b[0][2]++, font.sizeMS);
};
var buttonStyles = (cov_2hh8p0e50c().s[3]++, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  appearance: none;\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  height: ", ";\n  ", " max-width: 100%;\n  padding: 0 ", ";\n  -webkit-font-smoothing: antialiased;\n  -webkit-touch-callout: none;\n  text-rendering: optimizeLegibility;\n  cursor: pointer;\n  user-select: none;\n  text-align: center;\n  vertical-align: middle;\n  text-decoration: none;\n  text-transform: none;\n  outline: 0;\n  color: ", ";\n  background-color: ", ";\n  margin: 0;\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n\n  font-size: ", ";\n\n  will-change: border-color, background;\n  transition: border-color linear 50ms, background linear 50ms;\n\n  ", " ", " & > svg {\n    vertical-align: middle;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  cov_2hh8p0e50c().f[1]++;
  cov_2hh8p0e50c().s[4]++;
  return "calc((2 + ".concat(props.lines, ") * ").concat(getFontSize(props), ")");
}, function (props) {
  cov_2hh8p0e50c().f[2]++;
  cov_2hh8p0e50c().s[5]++;
  return (cov_2hh8p0e50c().b[1][0]++, props.lines === 1) && (cov_2hh8p0e50c().b[1][1]++, "line-height: calc(3 * ".concat(getFontSize(props), " - ").concat(border.widthBase, " * 2);"));
}, spacing.medium, function (props) {
  cov_2hh8p0e50c().f[3]++;
  cov_2hh8p0e50c().s[6]++;
  return props.outline ? (cov_2hh8p0e50c().b[2][0]++, (cov_2hh8p0e50c().b[3][0]++, props.theme.button) && (cov_2hh8p0e50c().b[3][1]++, props.theme.button.backgroundColor)) : (cov_2hh8p0e50c().b[2][1]++, (cov_2hh8p0e50c().b[4][0]++, props.theme.button) && (cov_2hh8p0e50c().b[4][1]++, props.theme.button.textColor) || (cov_2hh8p0e50c().b[4][2]++, color.boxText));
}, function (props) {
  cov_2hh8p0e50c().f[4]++;
  cov_2hh8p0e50c().s[7]++;
  return props.outline ? (cov_2hh8p0e50c().b[5][0]++, 'transparent') : (cov_2hh8p0e50c().b[5][1]++, (cov_2hh8p0e50c().b[6][0]++, props.theme.button) && (cov_2hh8p0e50c().b[6][1]++, props.theme.button.backgroundColor) || (cov_2hh8p0e50c().b[6][2]++, color.boxBackground));
}, border.widthBase, function (props) {
  cov_2hh8p0e50c().f[5]++;
  cov_2hh8p0e50c().s[8]++;
  return props.outline ? (cov_2hh8p0e50c().b[7][0]++, (cov_2hh8p0e50c().b[8][0]++, props.theme.button) && (cov_2hh8p0e50c().b[8][1]++, props.theme.button.backgroundColor) || (cov_2hh8p0e50c().b[8][2]++, color.boxBackground)) : (cov_2hh8p0e50c().b[7][1]++, 'transparent');
}, function (props) {
  cov_2hh8p0e50c().f[6]++;
  cov_2hh8p0e50c().s[9]++;
  return (cov_2hh8p0e50c().b[9][0]++, props.theme.button) && (cov_2hh8p0e50c().b[9][1]++, props.theme.button.borderRadius) || (cov_2hh8p0e50c().b[9][2]++, border.radiusNone);
}, getFontSize, function (props) {
  cov_2hh8p0e50c().f[7]++;
  cov_2hh8p0e50c().s[10]++;
  return (cov_2hh8p0e50c().b[10][0]++, !props.disabled) && (cov_2hh8p0e50c().b[10][1]++, "\n    &:hover,\n    &:focus {\n      text-decoration: none;\n      background-color: ".concat((0, _polished.lighten)(0.05, (cov_2hh8p0e50c().b[11][0]++, props.theme.button) && (cov_2hh8p0e50c().b[11][1]++, props.theme.button.backgroundColor) || (cov_2hh8p0e50c().b[11][2]++, color.boxBackground)), ";\n      color: ").concat((cov_2hh8p0e50c().b[12][0]++, props.theme.button) && (cov_2hh8p0e50c().b[12][1]++, props.theme.button.textColor) || (cov_2hh8p0e50c().b[12][2]++, color.boxText), ";\n      div > div > span > svg {\n        fill: ").concat((cov_2hh8p0e50c().b[13][0]++, props.theme.button) && (cov_2hh8p0e50c().b[13][1]++, props.theme.button.textColor) || (cov_2hh8p0e50c().b[13][2]++, color.boxText), ";\n      }\n    }\n    &:active {\n      background-color: ").concat((0, _polished.darken)(0.1, (cov_2hh8p0e50c().b[14][0]++, props.theme.button) && (cov_2hh8p0e50c().b[14][1]++, props.theme.button.backgroundColor) || (cov_2hh8p0e50c().b[14][2]++, color.boxBackground)), "\n    }\n    &:focus {\n      border: 1px solid black;\n      outline: 1px solid black;\n      outline-style: auto;\n    }\n  "));
}, function (props) {
  cov_2hh8p0e50c().f[8]++;
  cov_2hh8p0e50c().s[11]++;
  return (cov_2hh8p0e50c().b[15][0]++, props.width) && (cov_2hh8p0e50c().b[15][1]++, "\n      width: ".concat(props.width, ";\n      overflow: hidden;\n    "));
}, function (props) {
  cov_2hh8p0e50c().f[9]++;
  cov_2hh8p0e50c().s[12]++;
  return (cov_2hh8p0e50c().b[16][0]++, props.small) && (cov_2hh8p0e50c().b[16][1]++, "\n    height: calc(2 * ".concat(getFontSize(props), ");\n    padding: 0 ").concat(spacing.small, ";\n    line-height: calc(2 * ").concat(getFontSize(props), " - ").concat(border.widthBase, " * 2);\n  "));
}, function (props) {
  cov_2hh8p0e50c().f[10]++;
  cov_2hh8p0e50c().s[13]++;
  return (cov_2hh8p0e50c().b[17][0]++, props.large) && (cov_2hh8p0e50c().b[17][1]++, "\n    font-size: ".concat(font.sizeL, ";\n  "));
}, function (props) {
  cov_2hh8p0e50c().f[11]++;
  cov_2hh8p0e50c().s[14]++;
  return (cov_2hh8p0e50c().b[18][0]++, props.disabled) && (cov_2hh8p0e50c().b[18][1]++, props.neutral) && (cov_2hh8p0e50c().b[18][2]++, "\n    color: ".concat(color.disabledText, ";\n    background-color: ").concat(color.disabledBackground, ";\n\n    &:hover,\n    &:focus {\n      color: ").concat((0, _polished.lighten)(0.1, color.disabledText), ";\n      background-color: ").concat((0, _polished.lighten)(0.1, color.disabledBackground), ";\n    }\n    &:active {\n      background-color: ").concat((0, _polished.darken)(0.1, color.disabledBackground), "\n    }\n  "));
}, function (props) {
  cov_2hh8p0e50c().f[12]++;
  cov_2hh8p0e50c().s[15]++;
  return (cov_2hh8p0e50c().b[19][0]++, props.flat) && (cov_2hh8p0e50c().b[19][1]++, "\n    background: none;\n    color: ".concat((cov_2hh8p0e50c().b[20][0]++, props.theme.button) && (cov_2hh8p0e50c().b[20][1]++, props.theme.button.backgroundColor) || (cov_2hh8p0e50c().b[20][2]++, color.boxBackground), ";\n\n    &:not(:disabled):hover,\n    &:not(:disabled):focus {\n      background: none;\n      color: ").concat((cov_2hh8p0e50c().b[21][0]++, props.theme.button) && (cov_2hh8p0e50c().b[21][1]++, props.theme.button.backgroundColor) || (cov_2hh8p0e50c().b[21][2]++, color.boxBackground), ";\n    }\n  "));
}, function (props) {
  cov_2hh8p0e50c().f[13]++;
  cov_2hh8p0e50c().s[16]++;
  return (cov_2hh8p0e50c().b[22][0]++, props.disabled) && (cov_2hh8p0e50c().b[22][1]++, "\n      background-color: ".concat(color.disabledBackground, ";\n      color: ").concat(color.disabledText, ";\n      cursor: not-allowed;\n    "));
}));
var _default = exports.default = buttonStyles;